var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-message"},[_c('p',[_vm._v("Page not found")]),_c('router-link',{staticClass:"btn",attrs:{"to":"/"}},[_vm._v("Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }